import { render, staticRenderFns } from "./Model16.vue?vue&type=template&id=08a99e17&scoped=true&"
import script from "./Model16.vue?vue&type=script&lang=js&"
export * from "./Model16.vue?vue&type=script&lang=js&"
import style0 from "./Model16.vue?vue&type=style&index=0&id=08a99e17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a99e17",
  null
  
)

export default component.exports